import Header from "./components/header";
import Content from "./components/maincontent";

function Homepage() {
  return (
    <div>
      <Header />
      <div className="pb-4"></div>
      <Content />
    </div>
  );
}
export default Homepage;
